import { subCompanyCreditProviderApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const SUB_COMPANY_CREDIT_PROVIDER_ACTION_TYPE = createNamedActions(
  'subCompanyCreditProvider',
  {
    GET_CREDIT_PROVIDER: 'GET_CREDIT_PROVIDER',
    UPDATE_CREDIT_PROVIDER: 'UPDATE_CREDIT_PROVIDER',
    DELETE_CREDIT_PROVIDER: 'DELETE_CREDIT_PROVIDER',
    RESET_STATE: 'RESET_STATE',
  },
);

export const getSubCompanyCreditProviderAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await subCompanyCreditProviderApi.getSubCompanyCreditProvider(params);

  return dispatch({
    type: SUB_COMPANY_CREDIT_PROVIDER_ACTION_TYPE.GET_CREDIT_PROVIDER,
    payload: data,
    meta: { subCompanyId: params.subCompanyId },
  });
});

export const updateSubCompanyCreditProviderAction = catchAsyncActionError(
  params => async dispatch => {
    const { data } = await subCompanyCreditProviderApi.updateSubCompanyCreditProvider(params);

    return dispatch({
      type: SUB_COMPANY_CREDIT_PROVIDER_ACTION_TYPE.UPDATE_CREDIT_PROVIDER,
      payload: data,
      meta: { subCompanyId: params.subCompanyId },
    });
  },
);

export const deleteSubCompanyCreditProviderAction = catchAsyncActionError(
  params => async dispatch => {
    await subCompanyCreditProviderApi.deleteSubCompanyCreditProvider(params);

    return dispatch({
      type: SUB_COMPANY_CREDIT_PROVIDER_ACTION_TYPE.DELETE_CREDIT_PROVIDER,
      meta: { subCompanyId: params.subCompanyId },
    });
  },
);

export const resetSubCompanyCreditProviderAction = () => ({
  type: SUB_COMPANY_CREDIT_PROVIDER_ACTION_TYPE.RESET_STATE,
});
